import { ChargeStateXref } from '@/api/fee/charge-state-xref';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';

import { UpdateChargeStateXref } from './sheet-update';

export const columns: ColumnDef<ChargeStateXref>[] = [
	{
		accessorKey: 'state',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					State
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.state}
				</div>
			);
		},
	},
	{
		accessorKey: 'feeDescId',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					FeeDescId
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.feeDescId}
				</div>
			);
		},
	},
	{
		accessorKey: 'isExpired',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Expired
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center">
					<Checkbox checked={!!row.original.isExpired} disabled />
				</div>
			);
		},
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>
				<UpdateChargeStateXref chargeStateXref={row.original} />
			</div>
		),
	},
];
